import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api/client';
import { Logo } from '../components/Logo';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setError(null); setSubmitting(true);
    try {
      await api('/api/auth/forgot-password', {
        method: 'POST',
        body: JSON.stringify({ email: email.trim() }),
      });
      setDone(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Request failed');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="auth-screen">
      <form className="auth-card" onSubmit={(e) => void onSubmit(e)} noValidate>
        <div className="auth-brand"><Logo size={48} ariaLabel="VietSurvive" /><span>VietSurvive</span></div>
        <h1 className="auth-title">Reset password</h1>
        <p className="auth-lede">Enter your email and we'll send a reset link.</p>

        {done ? (
          <>
            <div className="info-banner" role="status">
              If an account exists for that email, a reset link is on its way. Check your inbox (and spam folder).
            </div>
            <Link to="/login" className="btn-secondary btn-block" style={{ textAlign: 'center' }}>Back to sign in</Link>
          </>
        ) : (
          <>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input id="email" type="email" required autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} disabled={submitting} />
            </div>
            {error && <div className="form-error" role="alert">{error}</div>}
            <button type="submit" className="btn-primary btn-block" disabled={submitting}>
              {submitting ? 'Sending…' : 'Send reset link'}
            </button>
            <Link to="/login" className="btn-link" style={{ textAlign: 'center', marginTop: 8 }}>Back to sign in</Link>
          </>
        )}
      </form>
      <p className="auth-copyright">© {new Date().getFullYear()} VietSurvive</p>
    </div>
  );
}
